var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.item
    ? _c(
        "div",
        {
          staticClass: "modal in",
          class: { "fade modal-open": _vm.isModalOpen },
          on: {
            click: function($event) {
              if ($event.target !== $event.currentTarget) {
                return null
              }
              $event.stopPropagation()
              return _vm.closeModal($event)
            }
          }
        },
        [
          _c("div", { staticClass: "modal-dialog" }, [
            _c("div", { staticClass: "modal-content" }, [
              _c(
                "div",
                { staticClass: "modal__header", class: _vm.headerClasses },
                [
                  _vm.header
                    ? _c("HeaderItem", {
                        attrs: {
                          header: _vm.header,
                          "is-last": _vm.isLast,
                          "is-first": _vm.isFirst
                        }
                      })
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "modal-body" },
                [
                  _c(_vm.itemType, {
                    tag: "component",
                    attrs: { item: _vm.item }
                  }),
                  _vm._v(" "),
                  _c("CommentsContainer")
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "modal__footer" })
            ])
          ])
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }